import { useQuery } from '@tanstack/react-query'
import {
  getOtherSites,
  type OtherSiteFeature,
} from '../../services/farmMapping/otherSites/getOtherSites'
import { queryKeys } from './queryKeys'

// Stable select identity; the clone stops consumers' featureGroup rewrites reaching the cache.
const selectFeatures = (features: OtherSiteFeature[]): OtherSiteFeature[] =>
  structuredClone(features)

export const useOtherSites = ({ farmId }: { farmId: string | undefined }) =>
  useQuery({
    queryKey: queryKeys.otherSites(farmId),
    queryFn: ({ signal }) => getOtherSites({ farmId: farmId as string, signal }),
    enabled: !!farmId,
    select: selectFeatures,
  })
